export const INCOME_BREAKDOWNS_TABLE_ARIA_LABEL = 'Розшифровка загальної суми доходів';
export const INCOME_BREAKDOWNS_TABLE_MIN_WIDTH = 1220;
export const INCOME_BREAKDOWNS_TABLE_HEADERS = [
  'Найменування контрагента',
  'ЄДРПОУ контрагента',
  'Рядок фінансової звітності',
  'Складова (вид) доходу',
  'Сума, тис. грн',
  'Питома вага, %',
] as const;
export const INCOME_BREAKDOWNS_TABLE_COLUMN_WIDTHS = [
  '27%',
  '12%',
  '14%',
  '27%',
  '10%',
  '10%',
] as const;
